import { authenticationRepositoryProvider, userWebRepositoryProvider } from './repositories';
export var repositoryProviders = [userWebRepositoryProvider, authenticationRepositoryProvider];